import * as React from "react";

const Invoices3: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="31" viewBox="0 0 23 31">
            <path fill="#FFF" d="M2.8125,27.1875 L19.6875,27.1875 L19.6875,9.375 L13.125,9.375 L13.125,2.8125 L2.8125,2.8125 L2.8125,27.1875 Z M2.8125,0 L15,0 L22.5,7.5 L22.5,27.1875 L22.5,30 L19.6875,30 L2.8125,30 L0,30 L0,27.1875 L0,2.8125 L0,0 L2.8125,0 Z M4.6875,5.625 L5.625,5.625 L10.3125,5.625 L11.25,5.625 L11.25,7.5 L10.3125,7.5 L5.625,7.5 L4.6875,7.5 L4.6875,5.625 Z M4.6875,9.375 L5.625,9.375 L10.3125,9.375 L11.25,9.375 L11.25,11.25 L10.3125,11.25 L5.625,11.25 L4.6875,11.25 L4.6875,9.375 Z M11.25,22.5 L12.1875,22.5 L16.875,22.5 L17.8125,22.5 L17.8125,24.375 L16.875,24.375 L12.1875,24.375 L11.25,24.375 L11.25,22.5 Z M17.8125,13.125 L17.8125,20.625 L4.6875,20.625 L4.6875,13.125 L17.8125,13.125 Z"
                transform="translate(.25 .75)" />
        </svg>
    );
};

export default React.memo(Invoices3);
